import { Card, CardContent, Typography, Grid, Stack, Box, Tooltip, CardMedia } from '@mui/material';
import { Driver } from 'iconsax-react';
import { useEffect, useState } from 'react';
import useAuth from 'hooks/useAuth';
import { useNavigate } from 'react-router-dom';
import { addFavoriteCourse } from 'services/course.service';
import Snackbar from 'utils/Snackbar';
import heartIcon from '../../assets/images/homepage/Heart.svg';
import heartFilledIcon from '../../assets/images/homepage/HeartFilled.svg';
import NoImage from 'assets/images/homepage/NoCourseImage.jpg';
import NoData from 'assets/images/img_no_data.png';

const SimpleCourseCard = (props: any) => {
    const { user }: any = useAuth();
    const [listData, setListData] = useState<any>([]);
    const navigate = useNavigate();

    useEffect(() => {
        setListData(props.courses)
    }, [props]);

    const handleLikeClick = (courseId: any, liked: boolean) => {
        addFavoriteCourse({
            userId: user?._id,
            courseId
        })
            .then((res) => {
                if (res?.status === 200 || res?.status === 201) {
                    
                    if (liked) {
                        Snackbar('Course successfully added to your favorite course list!', 'success');
                        setListData((prev: any) => prev.map((item: any) => {
                            if (item._id === courseId) {
                                item.favoriteCoursesByUser.push(user?._id)
                                return item
                            } else {
                                return item
                            }
                        }))
                    } else {
                        Snackbar('Course successfully removed from your favorite course list!', 'success');
                        setListData((prev: any) => prev.map((item: any) => {
                            if (item._id === courseId) {
                                item.favoriteCoursesByUser = item.favoriteCoursesByUser.filter((ids: string) => ids !== user?._id)
                                return item
                            } else {
                                return item
                            }
                        }))
                    }
                    props.handleFavCourseCount(liked)
                    // setListData(updatedListData);
                    // props.handleLiked();
                }
            })
            .catch((err) => {
                console.error('Error caught:', err);
                if (err?.response?.status === 403) {
                    const errorMessage = err?.response?.data?.message || "Something went wrong!!";
                    Snackbar(errorMessage, 'error');
                } else {
                    // const errorMessage = err?.response?.data?.message || 'An unexpected error occurred. Please try again later.';
                    Snackbar("Something went wrong!!", 'error');
                }
            });
    };


    return (
        <>
            <Grid
                container
                spacing={2}
                sx={{ justifyContent: !listData || listData?.length === 0 ? 'center' : 'flex-start' }}
            >
                {listData && listData?.length > 0 ? (
                    listData?.map((item: any, index: any) => {
                        const currentItem = item?.courseId ? item?.courseId : item;
                        return (
                            <Grid
                                key={index}
                                item
                                xs={12}
                                sm={6}
                            >
                                <Card
                                    sx={{
                                        height: '320px',
                                        borderRadius: '20px',
                                        border: '1px solid #D8D8D8',
                                        cursor: 'pointer',
                                        boxShadow: 'none',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        overflow: 'hidden'
                                    }}
                                >
                                    {/* Image */}
                                    <Box
                                        sx={{
                                            width: '100%',
                                            height: '220px',
                                            overflow: 'hidden',
                                            borderRadius: '20px',
                                            position: 'relative',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        <CardMedia
                                            component="img"
                                            onClick={() => {
                                                navigate(user?.type === 'faculty' ? '/mylearning/course' : '/view-course', {
                                                    state: user?.type === 'faculty' ? { courseId: currentItem?._id, userId: user?._id } : { courseData: currentItem }
                                                });
                                            }}
                                            sx={{
                                                width: '100%',
                                                height: '220px',
                                                objectFit: 'cover'
                                            }}
                                            src={
                                                currentItem?.image?.path
                                                    ? process.env.REACT_APP_FILE_URL + currentItem?.image?.path
                                                    : currentItem?.image?.file
                                                        ? `data:${currentItem?.image?.mimetype};base64,${currentItem?.image?.file}`
                                                        : NoImage
                                            }
                                            alt={currentItem?.name}
                                        />
                                        <>
                                            <Box
                                                sx={{
                                                    position: 'absolute',
                                                    top: '10px',
                                                    right: '10px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '8px',
                                                    zIndex: 1
                                                }}
                                            >
                                                {/* Heart Image */}
                                                <Box
                                                    sx={{
                                                        width: '30px',
                                                        height: '30px',
                                                        backgroundColor: '#ffffff',
                                                        borderRadius: '50%',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)',
                                                        cursor: 'pointer'
                                                    }}
                                                >
                                                    {currentItem?.favoriteCoursesByUser?.includes(user?._id) ? (
                                                        <img
                                                            src={heartFilledIcon}
                                                            onClick={() => {
                                                                handleLikeClick(currentItem?._id, false);
                                                            }}
                                                            width="20"
                                                            height="20"
                                                            style={{ objectFit: 'contain', width: '100%' }}
                                                        />
                                                    ) : (
                                                        <img
                                                            src={heartIcon}
                                                            onClick={() => {
                                                                handleLikeClick(currentItem?._id, true);
                                                            }}
                                                            width="20"
                                                            height="20"
                                                            style={{ objectFit: 'contain', width: '100%' }}
                                                        />
                                                    )}
                                                    {/*                         
                                                            <Heart
                                                                color="#cc4343"
                                                                ={currentItem?.favoriteCoursesByUser?.includes(user?._id) ? 'Bold' : 'Linear'}
                                                                onClick={() => {
                                                                handleLikeClick(inFav ? currentItem?._id : currentItem?._id);
                                                                }}
                                                            /> */
                                                    }
                                                </Box>


                                                {/* Medal Icon */}
                                                {/* {progressItem?.certificateContent?.pdf && (
                          <Box
                            sx={{
                              width: '30px',
                              height: '30px',
                              backgroundColor: '#ffffff',
                              borderRadius: '50%',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)',
                              cursor: 'pointer'
                            }}
                          >
                            <Tooltip title="Certificate">
                              <Medal
                                onClick={() => {
                                  navigate(
                                    `/account/accomplishments/verify/${item?.courses?.certificateContent?.code || item?.certificateContent?.code
                                    }`
                                  );
                                }}
                              />
                            </Tooltip>
                          </Box>
                                                )} */}
                                            </Box>
                                        </>
                                    </Box>

                                    <CardContent
                                        sx={{ padding: 0 }}
                                        onClick={() => {
                                            navigate(user?.type === 'faculty' ? '/mylearning/course' : '/view-course', {
                                                state: user?.type === 'faculty' ? { courseId: currentItem?._id, userId: user?._id } : { courseData: currentItem }
                                            });
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                px: 2,
                                                display: 'flex',
                                                flexDirection: 'column',
                                                overflow: 'hidden'
                                            }}
                                        >
                                            <Stack
                                                direction="row"
                                                alignItems="center"
                                                justifyContent="space-between"
                                                sx={{ overflow: 'hidden', mt: 1 }}
                                            >
                                                <Tooltip title={currentItem?.name}>
                                                    <Typography
                                                        fontFamily={'poppins'}
                                                        sx={{
                                                            color: '#222222',
                                                            fontSize: '18px',
                                                            fontWeight: '600',
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis',
                                                            display: '-webkit-box',
                                                            WebkitLineClamp: '1',
                                                            WebkitBoxOrient: 'vertical',
                                                            cursor: 'pointer'
                                                        }}
                                                        onClick={() => {
                                                            navigate('/learner/course/info', {
                                                                state: { rowData: currentItem._id, createdBy: currentItem?.createdBy?._id }
                                                            });
                                                        }}
                                                    >
                                                        {currentItem?.name}
                                                    </Typography>
                                                </Tooltip>
                                            </Stack>
                                            <Stack
                                                direction="row"
                                                alignItems="center"
                                                justifyContent="space-between"
                                                spacing={2}
                                                sx={{ overflow: 'hidden', mt: 1, flexWrap: 'nowrap' }}
                                            >
                                                <Stack direction="column" spacing={1} sx={{ flex: 1, minWidth: 0 }}>
                                                    <Grid container spacing={0} sx={{ marginTop: 1 }} justifyContent="space-between">
                                                        <Stack direction={'row'} justifyContent={'space-between'}>
                                                            <Stack direction={'column'}>
                                                                <Typography sx={{ display: 'flex', alignItems: 'center' }}>
                                                                    <Driver size={16} />
                                                                    &nbsp;{currentItem?.section?.length} Modules
                                                                </Typography>
                                                                {/* <Typography sx={{ display: 'flex', alignItems: 'center' }}>
                                                                    <PlayCircle size={16} />
                                                                    &nbsp;{currentItem?.contentId?.length} Lessons
                                                                </Typography> */}
                                                            </Stack>
                                                        </Stack>
                                                    </Grid>
                                                    <Tooltip
                                                        title={currentItem?.createdBy?.firstName}
                                                    >
                                                        <Typography
                                                            fontFamily={'poppins'}
                                                            sx={{
                                                                color: '#999999',
                                                                fontSize: { lg: '12px', md: '10px' },
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                gap: '4px',
                                                                cursor: 'default'
                                                            }}
                                                        >
                                                            <span style={{ color: '#222222', whiteSpace: 'nowrap', fontWeight: '400' }}>Assigned ESO:</span>
                                                            <span
                                                                style={{
                                                                    color: '#222222',
                                                                    fontWeight: '600',
                                                                    overflow: 'hidden',
                                                                    textOverflow: 'ellipsis',
                                                                    whiteSpace: 'nowrap',
                                                                    display: 'inline-block',
                                                                    maxWidth: '100%'
                                                                }}
                                                            >
                                                                {currentItem?.createdBy?.firstName}{' '}
                                                                <span
                                                                    style={{
                                                                        overflow: 'hidden',
                                                                        whiteSpace: 'nowrap',
                                                                        display: 'inline-block',
                                                                        maxWidth: '120px',
                                                                        verticalAlign: 'top'
                                                                    }}
                                                                >
                                                                    {currentItem?.createdBy?.lastName}
                                                                </span>
                                                            </span>
                                                        </Typography>
                                                    </Tooltip>
                                                </Stack>
                                            </Stack>
                                        </Box>
                                    </CardContent>
                                </Card>
                            </Grid>
                        );
                    })
                ) : (
                    <>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            <img src={NoData} alt="No Courses" style={{ width: '200px', height: '200px' }} />
                            <Typography fontFamily="poppins" variant="h5" sx={{ color: '#202027', fontWeight: '700', mt: 2 }}>
                                No Courses found!!
                            </Typography>
                        </Box>
                    </>
                )}
            </Grid>
        </>
    );
};

export default SimpleCourseCard;
